import * as Yup from "yup";

const SportSchema = Yup.object().shape({
  name: Yup.string().trim().required("Required"),
  displayOrder: Yup.number().required("Required"),
});

export default SportSchema;
